"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.json = exports.text = exports.buffer = void 0;
const content_type_1 = __importDefault(require("content-type"));
const raw_body_1 = __importDefault(require("raw-body"));
const errors_1 = require("./errors");
const rawBodyMap = new WeakMap();
async function buffer(req, { limit = '1mb' } = { limit: '1mb' }) {
    const length = req.headers['content-length'];
    const body = rawBodyMap.get(req);
    if (body) {
        return body;
    }
    try {
        const buf = await (0, raw_body_1.default)(req, { limit, length });
        rawBodyMap.set(req, buf);
        return buf;
    }
    catch (err) {
        throw new errors_1.MicriBodyError(err, limit);
    }
}
exports.buffer = buffer;
async function text(req, { limit = '1mb', encoding } = { limit: '1mb' }) {
    const type = req.headers['content-type'] || 'text/plain';
    const length = req.headers['content-length'];
    const body = rawBodyMap.get(req);
    if (body) {
        return body;
    }
    if (encoding === undefined) {
        encoding = content_type_1.default.parse(type).parameters.charset;
    }
    try {
        const buf = await (0, raw_body_1.default)(req, { limit, length, encoding });
        rawBodyMap.set(req, buf);
        return buf.toString();
    }
    catch (err) {
        throw new errors_1.MicriBodyError(err, limit);
    }
}
exports.text = text;
function parseJSON(str) {
    try {
        return JSON.parse(str);
    }
    catch (err) {
        throw new errors_1.MicriError(400, 'invalid_json', 'Invalid JSON', err);
    }
}
function json(req, opts) {
    return text(req, opts).then((body) => parseJSON(body));
}
exports.json = json;
//# sourceMappingURL=data:application/json;base64,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